import React from "react";
import { FaUsers, FaGlobe, FaMicrophone, FaLightbulb } from "react-icons/fa";
import { BRAND_COLOR } from "../../common/constants";

const features = [
  {
    icon: FaUsers,
    title: "Community Practice",
    text: "Participate in live group discussions to boost fluency and confidence.",
  },
  {
    icon: FaGlobe,
    title: "Global Connections",
    text: "Connect with learners worldwide and exchange ideas in real-time.",
  },
  {
    icon: FaMicrophone,
    title: "Expert Feedback",
    text: "Receive constructive guidance and personalized feedback from experienced mentors.",
  },
  {
    icon: FaLightbulb,
    title: "Mentor Insights",
    text: "Learn from the real-world experience and practical tips of our mentors.",
  },
];

const FeaturesSection = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <section
      id="features"
      style={{
        padding: isMobile ? "50px 16px" : "80px 20px",
        textAlign: "center",
        background: "linear-gradient(135deg, #e8f8fa, #ffffff)",
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "1.6rem" : "2rem",
          marginBottom: isMobile ? "30px" : "40px",
        }}
      >
        Why Choose Us?
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: isMobile ? "20px" : "40px",
          flexWrap: "wrap",
        }}
      >
        {features.map((feature, i) => {
          const Icon = feature.icon;

          return (
            <div
              key={i}
              style={{
                width: isMobile ? "100%" : "280px",
                maxWidth: "360px",
                padding: isMobile ? "18px" : "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                background: "white",
                textAlign: "center",
              }}
            >
              <Icon
                size={isMobile ? 32 : 40}
                color={BRAND_COLOR}
                style={{ marginBottom: 12 }}
              />

              <h3
                style={{
                  fontSize: isMobile ? "1.05rem" : "1.2rem",
                  marginBottom: 8,
                }}
              >
                {feature.title}
              </h3>

              <p
                style={{
                  fontSize: isMobile ? "0.95rem" : "1rem",
                  lineHeight: 1.5,
                  color: "#555",
                }}
              >
                {feature.text}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturesSection;
